import { useContext } from "react";
import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import { ClientsDataContext } from "@shared/features/common/ClientsData.context";
import { useAccountSetupAnalytics } from "analytics/accountSetup";
import { BOT_TYPE_ANALYTICS_MAPPING } from "features/bots/common/constants";

const useTrackSaveBlocked = () => {
  const { botType, subGroup } = useContext(BotFormContext)!;
  const trackAccountSetup = useAccountSetupAnalytics();
  const clientsData = useContext(ClientsDataContext);

  return (reason?: string) => {
    trackAccountSetup("Bot - Save Blocked", {
      bot_type: BOT_TYPE_ANALYTICS_MAPPING[botType],
      reason: reason?.slice(0, 300),
      has_account: !!clientsData?.notDeletedClientsData?.length,
      group_id: subGroup?.id,
    });
  };
};

export default useTrackSaveBlocked;
